export default "assets/images/icons/arrow-light-c4ddf8ff.svg";